<div class="timeframe-usage">

  <div class="tile menu-structure widget-menu-layer-1">

    <div class="menu-structure-layout no-field-space">
      <div class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></div>
      <div class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</div>
      <div class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></div>

      <div class="margin-left-25 structure-node-selection">
        <app-structure-node-selection (selectedStructureChanged)="onSelectedStructureChanged($event)"
          [selectedNode]="selectedStructureNode"></app-structure-node-selection>
      </div>

      <div class="item margin-left-25" [ngClass]="{'selected': isModeSelected('sums')}" (click)="selectMode('sums')">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.mode.sums"></sc-dictionary-label>
      </div>
      <div class="item" [ngClass]="{'selected': isModeSelected('transports')}" (click)="selectMode('transports')">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.mode.transports"></sc-dictionary-label>
      </div>
      <div class="item" [ngClass]="{'selected': isModeSelected('positions')}" (click)="selectMode('positions')">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.mode.positions"></sc-dictionary-label>
      </div>
    </div>
  </div>

  <div class="timeframes">
    <div class="row" *ngFor="let tfg of timeframeGroups">
      <div class="timeframe" [ngClass]="{ 'empty' :tf.bookings.length === 0 }"
        *ngFor="let tf of tfg.timeframes">
        <div class="label">
          {{tf.label}}
        </div>
        <div class="bookings">
          <div class="booking" *ngFor="let b of tf.bookings">
            <div>
              {{b.identifier}}
            </div>
            <div>
              {{b.line1}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
